import { Lerp } from './types'

export const lerp: Lerp = (min, max, amount) =>
  (1 - amount) * min + amount * max
